/*
  TravBuddies Rabattcode im Warenkorb
  Nimmt einen Code direkt im Warenkorb entgegen (/cart/update.js mit "discount"),
  prüft über cart.discount_codes[].applicable, ob Shopify ihn akzeptiert, und
  verwirft ungültige Codes wieder. Nach jeder Änderung läuft die Gratis-Zugaben-
  Logik (assets/tb-gwp.js) erneut, die bei einem gültigen Code die Zugaben entfernt.
*/
// Der Warenkorb wird nach jeder Änderung neu gerendert, dabei wird dieses Element
// ersetzt. Fehlermeldung und Eingabe deshalb außerhalb der Instanz merken.
let pendingNotice = null;

if (!customElements.get('cart-discount-form')) {
  customElements.define(
    'cart-discount-form',
    class CartDiscountForm extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.tb-discount__input');
        this.button = this.querySelector('.tb-discount__button');
        this.codes = this.querySelector('.tb-discount__codes');
        this.message = this.querySelector('.tb-discount__msg');

        this.button.addEventListener('click', () => this.apply());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            this.apply();
          }
        });

        if (pendingNotice) {
          this.input.value = pendingNotice.code || '';
          this.setMessage(pendingNotice.text, true);
          pendingNotice = null;
        }

        this.renderCodes();
      }

      async send(code) {
        return fetch(`${window.routes.cart_update_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        }).then((response) => response.json());
      }

      async apply() {
        const code = this.input.value.trim();
        if (!code || this.loading) return;
        this.setLoading(true);
        try {
          // Gratis-Zugaben blockieren jeden Code (nicht kombinierbar), deshalb erst raus damit.
          if (window.tbGwpApi) await window.tbGwpApi.suspend();

          const cart = await this.send(code);
          const entry = (cart.discount_codes || []).find((item) => item.code.toLowerCase() === code.toLowerCase());
          if (entry && entry.applicable) {
            this.input.value = '';
            this.setMessage('', false);
            // Zugaben bleiben draußen, solange der Code liegt – das entscheidet tb-gwp.js.
            if (window.tbGwpApi) await window.tbGwpApi.resume();
            await this.refresh();
          } else {
            // Ungültige Codes nicht im Warenkorb stehen lassen, Zugaben zurückholen.
            await this.send('');
            pendingNotice = { code, text: this.dataset.errorText || 'Dieser Code ist für deinen Warenkorb nicht gültig.' };
            this.setMessage(pendingNotice.text, true);
            if (window.tbGwpApi) await window.tbGwpApi.resume();
            this.renderCodes();
          }
        } catch (error) {
          if (window.tbGwpApi) await window.tbGwpApi.resume();
          console.warn('[tb-discount]', error);
          this.setMessage(this.dataset.errorText || 'Dieser Code ist für deinen Warenkorb nicht gültig.', true);
        } finally {
          this.setLoading(false);
        }
      }

      async remove() {
        if (this.loading) return;
        this.setLoading(true);
        try {
          await this.send('');
          this.setMessage('', false);
          await this.refresh();
        } catch (error) {
          console.warn('[tb-discount]', error);
        } finally {
          this.setLoading(false);
        }
      }

      async refresh() {
        // Zugaben-Logik und Warenkorb-Anzeige aktualisieren.
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tb-cart-discount' });
        }
        this.renderCodes();
      }

      async renderCodes() {
        let cart;
        try {
          cart = await fetch(`${window.routes.cart_url}.js`).then((response) => response.json());
        } catch (error) {
          return;
        }
        const active = (cart.discount_codes || []).filter((item) => item.applicable);
        this.codes.innerHTML = '';
        this.codes.hidden = active.length === 0;
        active.forEach((item) => {
          const chip = document.createElement('span');
          chip.className = 'tb-discount__chip';
          chip.textContent = item.code;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'tb-discount__chip-remove';
          remove.setAttribute('aria-label', `${item.code} entfernen`);
          remove.textContent = '×';
          remove.addEventListener('click', () => this.remove());
          chip.appendChild(remove);
          this.codes.appendChild(chip);
        });
      }

      setLoading(state) {
        this.loading = state;
        this.button.disabled = state;
        this.classList.toggle('tb-discount--loading', state);
      }

      setMessage(text, isError) {
        this.message.textContent = text;
        this.message.hidden = !text;
        this.message.classList.toggle('tb-discount__msg--error', !!isError);
      }
    }
  );
}
